import PropTypes from 'prop-types';
import React from 'react';

import './BackstageGrid.scss';

const ITEMS_PER_ROW = 4;

class BackstageGrid extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  renderPlaceholders = () => {
    // These placeholders exist to allow us to use flexbox space-around to
    // justify content and still have our last row look left aligned if it isn't
    // full
    if (this.props.children) {
      const placeholders = [];
      for (let i = 0; i < ITEMS_PER_ROW; i++) {
        placeholders.push(
          <div className='GridItem GridItem--placeholder' key={`placeholder${i}`}></div>,
        );
      }
      return placeholders;
    }
  };

  render() {
    return (
      <div className='BackstageGrid'>
        {this.props.children}
        {this.renderPlaceholders()}
      </div>
    );
  }
}

export default BackstageGrid;
